import { toBaseStudyEntity } from './study-entity.js';
import { checkDefined } from 'faro-common-model';
import { StudyEntityType } from './study-entity-type.js';
export const allocationRuleAttributeSizeMaxValue = 10000000;
export const allocationRuleAttributeNotesMaxLength = 250;
export function toAllocationRuleAttributes(allocationRuleAttributes) {
    checkDefined(allocationRuleAttributes.allocationRuleId, 'AllocationRuleAttributes', 'allocationRuleId');
    checkDefined(allocationRuleAttributes.variantId, 'AllocationRuleAttributes', 'variantId');
    checkDefined(allocationRuleAttributes.schemaId, 'AllocationRuleAttributes', 'schemaId');
    return {
        ...toBaseStudyEntity(allocationRuleAttributes, StudyEntityType.AllocationRuleAttributes),
        allocationRuleId: allocationRuleAttributes.allocationRuleId,
        schemaId: allocationRuleAttributes.schemaId,
        variantId: allocationRuleAttributes.variantId,
        size: allocationRuleAttributes.size,
        sizeConfiguration: toAllocationRuleSizeConfiguration(allocationRuleAttributes.sizeConfiguration),
        notes: allocationRuleAttributes.notes,
    };
}
function toAllocationRuleSizeConfiguration(sizeConfiguration) {
    return {
        sizeProvided: sizeConfiguration == null ? false : sizeConfiguration.sizeProvided,
        toBeDetermined: sizeConfiguration == null ? false : sizeConfiguration.toBeDetermined,
        terminable: sizeConfiguration == null ? false : sizeConfiguration.terminable,
    };
}
//# sourceMappingURL=allocation-rule-attributes.js.map